export default  {"src":"/_next/static/image/public/images/loader.651fd591006377c23fb9fb6c55420a64.gif","height":300,"width":300};